import { render, staticRenderFns } from "./TopluHacizGonderIslemDetayView.vue?vue&type=template&id=560f292e&scoped=true"
import script from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f292e",
  null
  
)

export default component.exports